import { uiCommonConfig } from './uiCommon.config';
import type { UiConfig } from './uiConfigTypes';

export const uiProdConfig: UiConfig = {
  // DO NOT SPREAD ANY OTHER CONFIG BESIDES THE COMMON CONFIG
  ...uiCommonConfig,

  amplitudeApiKey: '0269e3a80a8ad0861dfc6b320b44b293',
  authUrl: 'https://auth.fox.com/foxone/',
  brazeApiKey: 'd58e5cf4-c359-455a-9aac-caf21bf1d5ff',
  callbackUrl: 'https://fox.com/callback',
  clientId: '21af937a-0ed4-4321-b87f-51d3b93976d4',
  environment: 'production',
  environmentAlt: 'prod',
  googleTagManagerId: 'GTM-NK3RRW5Z',
  heapAppId: '3942292380',
  helpUrl: 'https://fox.com/help',
  isBrazeEnabled: true,
  isBrazeLoggingEnabled: false,
  isBrazeCustomLoggingEnabled: false,
  isDatadogEnabled: process.env.NODE_ENV !== 'development',
  isGoogleAnalyticsEnabled: true,
  manageAccountUrl: 'https://auth.fox.com/manage/foxone',
  manageSubscriptionUrl: 'https://subs.fox.com/manage',
  planSelectUrl: 'https://subs.fox.com/subscribe',
  planSelectEmployeeUrl: 'https://subs.fox.com/employee',
  playerUrl: 'https://prod.player.fox.digitalvideoplatform.com/wpf/v3/3.2.46/wpf_player.js',
  privacyOrgCode: 'fds',
  subscribeUrl: 'https://subs.fox.com/subscribe',
  withClock: false,
};
